var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"header-banner"},[_c('b-container',[_vm._t("default"),_c('button',{staticClass:"close-btn px-lg-4",attrs:{"type":"button","title":"Close Banner"},on:{"click":_vm.closeBanner}},[_c('i',{staticClass:"material-icons icon",attrs:{"aria-hidden":"true"}},[_vm._v("close")])])],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }